import * as React from 'react';

import { StickyScrollBtnContainer, useToggleStickyScrollBtn } from '../../StickyScrollBtn';

import { HeroBannerLayout, HeroBannerMobile } from '../../../components/HeroBanner';
import { PageLayout } from '../../../components/PageLayout';
import { Advantages } from '../../../components/Advantages';
import { Analytics } from '../../../components/Analytics';

import { smoothScrollIntoView, useIsDesktop } from '@cian/valuation-utils-component';
import { AddNewCardLayout } from 'shared/components/AddNewCard';
import { FiltersMobileContainer } from '../../FiltersContainer';
import { MyHomeFormContainer } from '../../MyHomeFormMicrofrontend';
import { FormAnnotationContainer } from '../../FormAnnotationContainer';

export const PageContainerA: React.FC = () => {
  const isDesktop = useIsDesktop();

  const containerRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(containerRef);

  const scrollToFilters = React.useCallback(() => {
    smoothScrollIntoView(containerRef.current as HTMLDivElement);
  }, []);

  return (
    <>
      {isDesktop ? (
        <HeroBannerLayout>
          <AddNewCardLayout containerRef={containerRef} annotation={<FormAnnotationContainer />}>
            <MyHomeFormContainer />
          </AddNewCardLayout>
        </HeroBannerLayout>
      ) : (
        <>
          <HeroBannerMobile containerRef={containerRef} />
          <FiltersMobileContainer />
        </>
      )}

      <PageLayout>
        {!isDesktop && <FormAnnotationContainer />}
        <Advantages />
        <Analytics />
      </PageLayout>

      <StickyScrollBtnContainer action={scrollToFilters} />
    </>
  );
};
